import { humanize } from "./dateString";
import { selectValue } from "../store/timezoneSlice";
import { store } from "../store";
import { formatDate, DateFormatType, isHumanizeFormat } from "../utils/dateFormat";

/**
 * Format a date string for display (non-React version)
 * Used in tooltips and other non-component contexts
 */
export function dateString(iso: string, { format, utc = false }: { format?: string; utc?: boolean }): string {
  if (!iso) return "";

  const date = new Date(iso);
  if (isNaN(date.getTime())) return "";

  // Handle humanize formats
  if (format && isHumanizeFormat(format)) {
    return humanize(date.getTime(), format.includes("Ago"));
  }

  // Get timezone from Redux store
  const timezone = selectValue(store.getState());
  const formatType = (format || "sec") as DateFormatType;

  return formatDate(iso, formatType, { timezone, utc });
}
